<template>
  <v-dialog max-width="60%" lazy persistentX v-model = "editDialog">
    <v-btn accent slot="activator">
    <v-icon left>present_to_all</v-icon>Full Details
    </v-btn>
    <v-card>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <video v-show="videoUrl" width="100%" :poster="imageUrl" :src="videoUrl" type="video/mp4" controls></video>
        <v-img v-if="!videoUrl" :src="imageUrl"></v-img>
        <v-btn v-if="content.allowEdit && (videoUrl || false)" :disabled="uploading" flat class="blue--text darken-1" >Replace Video</v-btn>
        <input v-if="content.allowEdit && (videoUrl || true)" type="file" style="display:none" ref="fileInput" 
          accept="image/*"
          @change="onFilePicked"
          />
         
         <v-btn v-if="content.allowEdit && imageUrl " :disabled="uploading" @click="onPickFile" flat class="blue--text darken-1" >Replace Image</v-btn>
         
         <div v-if="content.type=='title'" class="titlePreview" style="width: 480px;height: 288px;font-size: 30px;margin: auto;max-width:480px; max-height:288px;">
                        <div class=pTitle>{{content.title}}</div>
                        <div class=pSubtitle>{{content.subtitle}}</div>
                        <div v-if="false" class=pBody>{{content.body}}</div>
                        <div class=pFooter>{{content.footer}}</div>
                      </div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card-text>
           <v-text-field
                name="title"
                label="Title"
                id="title"
                v-model="content.title"
                required
            ></v-text-field>
            <div v-if="content.type!='title'">
            <v-text-field
                name="author"
                label="Author"
                id="author"
                v-model="content.artist"
                required
            ></v-text-field>
            <v-text-field v-if="content.web"
                name="url"
                label="URL"
                id="url"
                v-model="content.web"
                
            ></v-text-field>
            <v-textarea
                name="description"
                label="Description"
                id="description"
                v-model="content.description"
                
                required
            ></v-textarea>
            </div>
            <div v-else>
             <v-text-field
                name="subtitle"
                label="Subtitle"
                id="subtitle"
                v-model="content.subtitle">
              </v-text-field>
              <v-text-field
                name="footer"
                label="Footer"
                id="footer"
                v-model="content.footer">
              </v-text-field>
           </div>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
      <v-layout row wrap>
      <v-flex xs12>
      <v-card-actions>
      <v-btn flat class="blue--text darken-1" @click="editDialog = false">Close</v-btn>
      <v-btn v-if="content.allowEdit" flat class="blue--text darken-1" @click="doEdit">Save</v-btn>
      
      </v-card-actions>
      </v-flex>
      </v-layout>
    </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['content','imageUrl','videoUrl'],
    data () {
      return {
        editDialog: false
      }
    },
    computed:{
      showDetails(){
        return this.content.showDetails
      },
      uploading(){
        return this.$store.getters.uploading
      }
    },
    watch:{
      showDetails(val){
        if(val){
          this.editDialog=true
         
        }
       
      }
      
    },
    methods: {
      doEdit(){
        this.$store.dispatch('updateContentData',this.content)
        this.editDialog=false
      },
      onPickFile () {
        this.$refs.fileInput.click()
      },
      onFilePicked (event) {
        const files = event.target.files
        let filename = files[0].name
        if (filename.lastIndexOf('.') <= 0) {
          return alert('Please add a valid file')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {

          this.imageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
         this.$store.dispatch('replaceImage',{id:this.content.id,image:files[0]})
        //this.imageUrl = files[0]
      }
      
      
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Content/ViewContentDialogue.vue